module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1035-0eb7c54cd514938d3bb8f8cb055872f0.png";